import { render, staticRenderFns } from "./tymsg.vue?vue&type=template&id=5bf9f0b3&scoped=true&"
import script from "./tymsg.vue?vue&type=script&lang=js&"
export * from "./tymsg.vue?vue&type=script&lang=js&"
import style0 from "./tymsg.vue?vue&type=style&index=0&id=5bf9f0b3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9f0b3",
  null
  
)

export default component.exports